module.exports = __webpack_public_path__ + "static/img/image.c503cbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image.png
// module id = G71L
// module chunks = 0